import React from 'react';
import ReactDOM from 'react-dom/client';

import { WithTheme } from './styles';
import { PageRouter } from './pages';
import { TranslationProvider } from './i18n';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
	<React.StrictMode>
		<WithTheme>
			<TranslationProvider>
				<PageRouter />
			</TranslationProvider>
		</WithTheme>
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
